import { render } from "./register.vue?vue&type=template&id=ccdaa312&scoped=true"
import script from "./register.vue?vue&type=script&setup=true&lang=js"
export * from "./register.vue?vue&type=script&setup=true&lang=js"

import "./register.vue?vue&type=style&index=0&id=ccdaa312&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccdaa312"],['__file',"pages/EndataAuth/Account/App/components/profile/register.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ccdaa312"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ccdaa312', __exports__)) {
    api.reload('ccdaa312', __exports__)
  }
  
  module.hot.accept("./register.vue?vue&type=template&id=ccdaa312&scoped=true", () => {
    api.rerender('ccdaa312', render)
  })

}


export default __exports__